import React, { Component } from 'react';
import QvrfComponents from '../../qvrf_component';
import PropTypes from 'prop-types';
import QlikWebSocketManager from 'websockets/manager/QlikWebSocketManager';

class QvrfComponent extends Component {
    constructor(props) {
        super(props);
        this.qdtComponents = new QvrfComponents(
            this.props.options.config,
            this.props.options.connections,
            this.props.socket,
            this.props.pageId,
            this.props.addVisualisation
        );
    }
    componentDidMount() {
        const { type, props } = this.props;
        this.qdtComponents.render(type, props, this.node);
    }

    componentWillUnmount() {
        // QvrfComponents.unmountQvrfComponent(this.node)
        QvrfComponents.unmountQvrfComponent(this.node);
    }

    render() {
        return (
            <div
                style={{ width: '100%', height: this.props.props.height }}
                ref={(node) => {
                    this.node = node;
                }}
            />
        );
    }
}

QvrfComponent.propTypes = {
    options: PropTypes.object.isRequired,
    type: PropTypes.string.isRequired,
    props: PropTypes.object.isRequired,
    socket: PropTypes.instanceOf(QlikWebSocketManager),
};

QvrfComponent.defaultProps = {
    socket: null,
};

export default QvrfComponent;
